<template>
  <div>
    <v-overlay :value="showLoader">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-data-table
          :headers="categoryHeaders"
          :items="categories"
          style="font-size: 9pt"
          dense
         :items-per-page="20"
          fixed-header
          :search="search"
        >
          <template v-slot:top>
              <v-toolbar flat>
                  <v-text-field v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    class="ml-1"
                    single-line
                    hide-details
                    clearable
                  />
                  <v-btn class="text-xs ml-2" v-on:click="refresh" color="primary">
                      <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px" persistent>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary"
                                 dark
                                 class="mb-2 mr-3"
                                 v-bind="attrs"
                                 v-on="on">
                              New Category
                          </v-btn>
                      </template>
                      <v-card>
                          <v-overlay :value="showLoader">
                              <v-progress-circular indeterminate
                                                   color="primary"
                                                   :size="70"
                                                   :width="7"></v-progress-circular>
                          </v-overlay>
                          <v-card-title>
                              <span class="text-h5">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                              <v-container>
                                  <v-form v-model="isValid">
                                      <v-row>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-text-field v-if="editedIndex !== -1"
                                                            v-model="editedItem.programName"
                                                            label="Program"
                                                            disabled></v-text-field>
                                              <v-select v-else
                                                        v-model="editedItem.programName"
                                                        label="Program"
                                                        :items="programChoices"
                                                        item-text="programName"
                                                        item-value="programName"
                                                        :rules="[
                                                        (v)=>
                                                  !!v || 'Program is required',
                                                  ]"
                                                  v-on:change="(e) => changeShowType(e)"
                                                  >
                                              </v-select>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-text-field v-model="editedItem.categoryShowType"
                                                            label="Show Type"
                                                            disabled></v-text-field>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-text-field v-model="editedItem.categoryId"
                                                            label="Category"
                                                            :disabled="editedIndex !== -1"
                                                            :rules="[
                                                            (v)=>
                                                  !!v || 'Category ID is required',
                                                  (v) =>
                                                  v.length <= 10 || 'Category ID is too long.',
                                                  ]"
                                                  >
                                              </v-text-field>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-textarea v-model="editedItem.description"
                                                          label="Description"
                                                          rows="1"
                                                          auto-grow
                                                          :rules="[
                                                          (v)=>
                                                  !!v || 'Description is required',
                                                  (v) =>
                                                  v.length <= 51 || 'Description is too long.',
                                                  ]"
                                                  >
                                              </v-textarea>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-textarea v-model="editedItem.heading"
                                                          label="Heading"
                                                          rows="1"
                                                          auto-grow
                                                          :rules="[
                                                          (v)=>
                                                  v.length <= 50 || 'Heading is too long.',
                                                  ]"
                                                  >
                                              </v-textarea>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-radio-group v-model="editedItem.isSuffix">
                                                  <v-radio label="Prefix Title"
                                                           :value="false"></v-radio>
                                                  <v-radio label="Suffix Title"
                                                           :value="true"></v-radio>
                                              </v-radio-group>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-checkbox v-model="editedItem.isAscaOnly"
                                                          label="ASCA only?"></v-checkbox>
                                          </v-col>
                                          <v-col cols="12" sm="6" md="4">
                                              <v-checkbox v-model="editedItem.isShowResultsCategory"
                                                          label="Show results category?"></v-checkbox>
                                          </v-col>
                                      </v-row>
                                  </v-form>
                              </v-container>
                          </v-card-text>

                          <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="close">
                                  Cancel
                              </v-btn>
                              <v-btn color="blue darken-1"
                                     :disabled="!isValid"
                                     text
                                     @click="save">
                                  Save
                              </v-btn>
                          </v-card-actions>
                      </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                          <v-card-title style="word-break: break-word" class="text-h5">
                              Are you sure you want to delete this
                              category?
                          </v-card-title>
                          <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                              <v-spacer></v-spacer>
                          </v-card-actions>
                      </v-card>
                  </v-dialog>
              </v-toolbar>
          </template>
          <template v-slot:[`item.categoryId`]="{ item }">
            <v-chip
              small
              pill
              :color="getTitleColor(item.categoryId, item.categoryId)"
              dark
            >
              {{ item.categoryId }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="item.canDelete"
              small
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:[`item.isAscaOnly`]="{ item }">
            <font-awesome-icon
              v-if="item.isAscaOnly !== null"
              :icon="item.isAscaOnly ? 'check' : 'times'"
              :color="item.isAscaOnly ? 'green' : 'red'"
            />
            <span v-else></span>
          </template>
          <template v-slot:[`item.isManual`]="{ item }">
            <font-awesome-icon
              v-if="item.isManual !== null"
              :icon="item.isManual ? 'check' : 'times'"
              :color="item.isManual ? 'green' : 'red'"
            />
            <span v-else></span>
          </template>
          <template v-slot:[`item.isShowResultsCategory`]="{ item }">
            <font-awesome-icon
              v-if="item.isShowResultsCategory !== null"
              :icon="item.isShowResultsCategory ? 'check' : 'times'"
              :color="item.isShowResultsCategory ? 'green' : 'red'"
            />
            <span v-else></span>
          </template>
          <template v-slot:[`item.isSuffix`]="{ item }">
            <span v-if="item.isSuffix !== null">
              {{ item.isSuffix ? 'Suffix' : 'Prefix' }}
            </span>
            <span v-else></span>
          </template>

          
        </v-data-table>
        <v-snackbar v-model="snackbar" :color="snackbarColor" title>
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn color="dark" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import adminService from "@/services/adminService";
import categoryService from "@/services/admin/categoryService";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "CategoryManagement",
  data: function () {
    return {
      showReportDialog: false,
      dialog: false,
      dialogDelete: false,
      categories: [] as any,
      programChoices: [] as any,
      categoryHeaders: [
        { text: "Show Type", align: "left", value: "categoryShowType", width: "5%" },
        { text: "Program", align: "left", value: "programName", width: "10%" },
        { text: "Title", align: "left", value: "categoryId" },
        { text: "Prefix/Suffix", align: "left", value: "isSuffix"},
        { text: "Description (printed certificate)", align: "left", value: "description" },
        { text: "Heading (printed certificate)", align: "left", value: "heading" },
        { text: "ASCA Only", align: "left", value: "isAscaOnly" },
        { text: "Manual", align: "left", value: "isManual" },        
        { text: "Show Results Category", align: "left", value: "isShowResultsCategory" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      colors: [
        "#e51c23",
        "#e91e63",
        "#9c27b0",
        "#673ab7",
        "#3f51b5",
        "#5677fc",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#259b24",
        "#8bc34a",
        "#afb42b",
        "#ff9800",
        "#ff5722",
        "#795548",
        "#607d8b",
      ],
      search: "",
      editedIndex: -1,
      editedItem: {
        categoryId: "",
        categoryShowType: "",
        programName: "",
        isManual: false,
        description: "",
        isSuffix: true,
        isAscaOnly: false,
        heading: "",
        canDelete: false,
        isShowResultsCategory: false,
      },
      defaultItem: {
        categoryId: "",
        categoryShowType: "",
        programName: "",
        isManual: false,
        description: "",
        isSuffix: true,
        isAscaOnly: false,
        heading: "",
        canDelete: false,
        isShowResultsCategory: false,
      },
      snackbar: false,
      snackbarColor: "green",
      snackbarText: "",
      showLoader: false,
      isValid: true,
    };
  },
    methods: {
        changeShowType(e: any) {
            let idx = this.$data.programChoices.findIndex(
                (x: any) => x.programName === e
            );
            this.$data.editedItem.categoryShowType = this.$data.programChoices[idx].categoryShowType;
            this.$data.editedItem = Object.assign({}, this.$data.editedItem);
        },
        getTitleColor(titleName: string, titleId: number) {
            const text = `123${titleName}123`; //`${titleId}${titleName}${titleId}`
            var hash = 0;
            if (text.length === 0) return hash;
            for (var i = 0; i < text.length; i++) {
                hash = text.charCodeAt(i) + ((hash << 3) - hash);
                hash = hash & hash;
            }
            hash =
                ((hash % this.$data.colors.length) + this.$data.colors.length) %
                this.$data.colors.length;
            return this.$data.colors[hash];
        },
        editItem(item: any) {
            this.$data.editedIndex = (this as any).categories.indexOf(item);
            this.$data.editedItem = Object.assign({}, item);
            this.$data.dialog = true;
        },

        deleteItem(item: any) {
            this.$data.editedIndex = (this as any).categories.indexOf(item);
            this.$data.editedItem = Object.assign({}, item);
            this.$data.dialogDelete = true;
        },

        deleteItemConfirm() {
            this.$data.showLoader = true;
            categoryService
                .deleteCategory({
                    programName: this.$data.editedItem.programName,
                    categoryId: this.$data.editedItem.categoryId,
                })
                .then((res) => {
                    this.$data.showLoader = false;
                    if (res.success) {
                        this.$data.categories = res.certificateCategories;
                        this.$data.snackbar = true;
                        this.$data.snackbarColor = "green";
                        this.$data.snackbarText = "Category deleted successfully";
                    } else {
                        this.$data.snackbar = true;
                        this.$data.snackbarColor = "red";
                        this.$data.snackbarText = "Error while deleting category";
                    }
                })
                .catch((e: any) => {
                    this.$data.showLoader = false;
                    this.$data.snackbar = true;
                    this.$data.snackbarColor = "red";
                    const data = (e?.response ?? e)?.data;
                    const descriptiveMessage = data ? `Error(s): ${Object.values(data).join(" & ")}` : null
                    this.$data.snackbarText = descriptiveMessage ? descriptiveMessage
                        : e?.message ? e.message
                            : "Unknown error occurred when retrieving data.";
                });
            (this as any).closeDelete();
        },

        close() {
            this.$data.dialog = false;
            this.$nextTick(() => {
                this.$data.editedItem = Object.assign({}, this.$data.defaultItem);
                this.$data.editedIndex = -1;
            });
        },

        save() {
            this.$data.showLoader = true;
            if (this.$data.editedIndex > -1) {
                Object.assign(
                    (this as any).categories[this.$data.editedIndex],
                    this.$data.editedItem
                );
                this.$nextTick(() => {
                    categoryService
                        .updateCategory(this.$data.editedItem)
                        .then((res) => {
                            this.$data.showLoader = false;
                            if (res.success) {
                                (this as any).close();
                                this.$data.categories = res.certificateCategories;
                                this.$data.snackbar = true;
                                this.$data.snackbarColor = "green";
                                this.$data.snackbarText = "Category updated successfully";
                            } else {
                                this.$data.snackbar = true;
                                this.$data.snackbarColor = "red";
                                this.$data.snackbarText = "Error while updating category";
                            }
                        })
                        .catch((e: any) => {
                            this.$data.showLoader = false;
                            this.$data.snackbar = true;
                            this.$data.snackbarColor = "red";
                            const data = (e?.response ?? e)?.data;
                            const descriptiveMessage = data ? `Error(s): ${Object.values(data).join(" & ")}` : null
                            this.$data.snackbarText = descriptiveMessage ? descriptiveMessage
                                : e?.message ? e.message
                                    : "Unknown error occurred when retrieving data.";
                        });
                });
            } else {
                categoryService
                    .createCategory(this.$data.editedItem)
                    .then((res) => {
                        this.$data.showLoader = false;
                        if (res.success) {
                            (this as any).close();
                            this.$data.categories = res.certificateCategories;
                            this.$data.snackbar = true;
                            this.$data.snackbarColor = "green";
                            this.$data.snackbarText = "Category added successfully";
                        } else {
                            this.$data.snackbar = true;
                            this.$data.snackbarColor = "red";
                            this.$data.snackbarText = "Error while adding category";
                        }
                    })
                    .catch((e: any) => {
                        this.$data.showLoader = false;
                        this.$data.snackbar = true;
                        this.$data.snackbarColor = "red";
                        const data = (e?.response ?? e)?.data;
                        const descriptiveMessage = data ? `Error(s): ${Object.values(data).join(" & ")}` : null
                        this.$data.snackbarText = descriptiveMessage ? descriptiveMessage
                            : e?.message ? e.message
                                : "Unknown error occurred when retrieving data.";
                    });
            }
        },

        closeDelete() {
            this.$data.dialogDelete = false;
            this.$nextTick(() => {
                this.$data.editedItem = Object.assign({}, this.$data.defaultItem);
                this.$data.editedIndex = -1;
            });
        },
        refresh: function () {
            this.$data.showLoader = true;
            adminService.getPrograms().then((res) => {
                this.$data.programChoices = res.certificatePrograms;
            });
            categoryService.getTitleCategories().then((res) => {
                this.$data.categories = res.certificateCategories;
                this.$data.showLoader = false;
            });
        },
    },
    created: function () {
        this.refresh();
    },
  computed: {
      userInfo(): UserInfo {
          return this.$store.state.userInfo;
      },
      formTitle() {
          return this.$data.editedIndex === -1 ? "New Category" : "Edit Category";
      },
  },
});
</script>
